export enum SRVRecordProtocols {
  TCP = 'TCP',
  UDP = 'UDP',
  TLS = 'TLS',
}

export enum CAARecordTag {
  ISSUE = 'issue',
  ISSUE_WILD = 'issuewild',
  IODEF = 'iodef',
}

export interface DNSRecord {
  id: number;
  type: DNSRecordType;
  host: string;
  ttl: number;
  target: string;
  status: DNSRecordStatus;
  log?: string;
}

export interface DNSRecordCreate {
  type: DNSRecordType;
  host: string;
  ttl: number;
  target: string;
}

export interface CAARecordCreate extends DNSRecordCreate {
  flag: number;
  tag: CAARecordTag;
}

export interface SOARecordCreate extends DNSRecordCreate {
  responsible_domain: string;
  serial_number: number;
  refresh_interval: number;
  retry_interval: number;
  expire_interval: number;
  neg_cache_ttl: number;
}

export interface SRVRecordCreate extends DNSRecordCreate {
  service: string;
  protocol: SRVRecordProtocols;
  priority: number;
  weight: number;
  port: number;
}

export interface MXRecordCreate extends DNSRecordCreate {
  priority: number;
}

export enum DNSRecordType {
  'A' = 'A',
  'AAAA' = 'AAAA',
  'CNAME' = 'CNAME',
  'NS' = 'NS',
  'MX' = 'MX',
  'TXT' = 'TXT',
  'PTR' = 'PTR',
  'SRV' = 'SRV',
  'SOA' = 'SOA',
  'SPF' = 'SPF',
  'CAA' = 'CAA',
  'LUA' = 'LUA',
  'DKIM' = 'DKIM',
}

export enum DNSRecordStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  PENDING = 'PENDING',
  SYNCERROR = 'SYNC_ERROR',
  STAGED_FOR_CREATION = 'STAGED_FOR_CREATION',
  STAGED_FOR_DELETION = 'STAGED_FOR_DELETION',
}

export interface DNSZoneRecord {
  id: number;
  target: string;
  type: DNSRecordType;
  content: Partial<DNSRecord>;
  status: DNSRecordStatus;
  createdAt: Date;
}

export enum DNSZoneStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  PENDING = 'PENDING',
  SYNCERROR = 'SYNC_ERROR',
  DUPLICATE = 'DUPLICATE',
}

export interface DNSZones {
  id: number;
  domain: string;
  websiteId: number;
  status: DNSZoneStatus;
  adminOnly: boolean;
  installation: DNSZoneInstallation;
  records: DNSZoneRecord[];
  serverHostname?: string;
}

export interface DNSZoneInstallation {
  domain: string;
  dnsIP: string;
  server: string;
}

export interface CreateDNSZones {
  server: string; // Server ID
  websiteId: number;
  adminOnly: boolean; // False by default
  overwrite: boolean;
}

export interface DNSRecords {
  id: number;
  type: DNSRecordType;
  host: string;
  ttl: number;
}

export interface DNSRecordTemp extends DNSZoneRecord {
  content: Partial<DNSRecord> & { priority?: number };
}

export interface DNSDepartmentTemp {
  departmentId: string;
}
